import React, { useEffect, useState } from 'react';
import Post from './Post';

const NewsItem = (props) => {
    
    const [state, setState] = useState({
        activate: props.postSeq == props.data.postdata.postSeq ? true : false,
        commentCount: ''
    });

    useEffect(() => {
        setState(prev => { return {
            ...prev,
            activate: props.postSeq == props.data.postdata.postSeq ? true : false
        }});
    }, [props.data.postdata]);

    useEffect(() => {
        if (state.activate) {
            setTimeout(()=>{
                const container = document.querySelector('.container');
                container.scrollTo({
                    top: document.getElementById(props.data.postdata.postSeq)?.offsetTop - container.offsetTop,
                    behavior: 'smooth'
                });
            }, 100)
        }
    }, [state.activate]);
    
    const clickPostNode = (e, activate) => {
        setState(prev => { return {
            ...prev,
            activate: !state.activate,
        }});
    };

    const executeFetch = (input) => {        
        props.executeFetch(input);
    };


    return (
        <div id={props.data.postdata.postSeq} className={"item"}>
            <Post activate={state.activate} postdata={props.data.postdata} clickPostNode={clickPostNode} commentCount={state.commentCount} isAccessFromHome={props.postSeq == props.data.postdata.postSeq ? true : false} executeFetch={executeFetch} setSelectedPost={props.setSelectedPost} />
        </div>
    );
};

export default NewsItem;